import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaBars, FaTimes } from 'react-icons/fa';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAboutSubmenuOpen, setIsAboutSubmenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsAboutSubmenuOpen(false);
  };

  return (
    <header id='masthead' itemScope itemType='https://schema.org/WPHeader'>
      {/* Top Header Section */}
      <section className='top-header-section'>
        <div className='container'>
          <div className='top-header-left'>
            <ul className='contact-info'>
              <li>
                <a href='https://g.co/kgs/ufC5CZe'>
                  <FaMapMarkerAlt className='icon' />
                  <span>INDIA,UAE,EGYPT,GEORGIA</span>
                </a>
              </li>
              <li>
                <a href='mailto:admin@destnation.org'>
                  <FaEnvelope className='icon' />
                  <span>admin@destnation.org</span>
                </a>
              </li>
              <li>
                <a href='tel:+971581236700'>
                  <FaPhone className='icon' />
                  <span>+971 581236700</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Main Header Section */}
      <section className='main-header-section'>
        <div className='container'>
          <div className='header-left'>
            <div className='logo-container'>
              <Link to='/'>
                <img src='/assets/img/logo/logo.webp' alt='Logo' style={{ height: '60px' }} />
              </Link>
            </div>

            <nav className='main-navigation'>
              <button
                className='mobile-menu-toggle'
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label='Toggle menu'
              >
                {isMenuOpen ? <FaTimes /> : <FaBars />}
              </button>

              <div className={`menu-wrapper ${isMenuOpen ? 'open' : ''}`}>
                <ul className='main-menu'>
                  <li className='menu-item current-menu-item'>
                    <Link to='/' onClick={closeMenu}>
                      Home
                    </Link>
                  </li>
                  <li
                    className='menu-item has-submenu'
                    onMouseEnter={() => setIsAboutSubmenuOpen(true)}
                    onMouseLeave={() => setIsAboutSubmenuOpen(false)}
                  >
                    <Link to='/about-us' onClick={closeMenu}>
                      About Us
                    </Link>
                    <ul className={`sub-menu ${isAboutSubmenuOpen ? 'open' : ''}`}>
                      <li>
                        <Link to='/team' onClick={closeMenu}>
                          Team
                        </Link>
                      </li>
                      <li>
                        <Link to='/testimonials' onClick={closeMenu}>
                          Testimonials
                        </Link>
                      </li>
                      <li>
                        <Link to='/gallery' onClick={closeMenu}>
                          Gallery
                        </Link>
                      </li>
                      <li>
                        <Link to='/' onClick={closeMenu}>
                          Career
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className='menu-item'>
                    <Link to='/universities' onClick={closeMenu}>
                      Universities
                    </Link>
                  </li>
                  <li className='menu-item'>
                    <Link to='/features' onClick={closeMenu}>
                      Features
                    </Link>
                  </li>
                  <li className='menu-item'>
                    <Link to='/admission' onClick={closeMenu}>
                      Admission
                    </Link>
                  </li>
                  <li className='menu-item'>
                    <Link to='/blogs' onClick={closeMenu}>
                      Blogs
                    </Link>
                  </li>
                  <li className='menu-item'>
                    <Link to='/contact-us' onClick={closeMenu}>
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>

          <div className='header-right'>
            <div className='cta-box'>
              <a href='tel:+971581236700' className='cta-link'>
                <div className='cta-icon'>
                  <FaPhone />
                </div>
                <div className='cta-content'>
                  <h3>Have Any Questions?</h3>
                  <h3>+971 581236700</h3>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </header>
  );
};

export default Header;
